import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import 'firebase/firestore';

export default class Firebase {
  private static _instance: Firebase;
  private _db!: firebase.firestore.Firestore;
  private _auth!: firebase.auth.Auth;
  private _functions!: firebase.functions.Functions;

  private constructor() {

    firebase.initializeApp({
      apiKey: process.env.VUE_APP_APIKEY,
      authDomain: process.env.VUE_APP_AUTHDOMAIN,
      projectId: process.env.VUE_APP_PROJECTID,
      storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
      appId: process.env.VUE_APP_APPID
    });
    this._auth = firebase.auth();
    this._db = firebase.firestore();
    this._functions = firebase.functions();

    // if(process.env.VUE_APP_FUNCTIONS_EMULATOR_HOST){
    //   this._functions.useFunctionsEmulator(
    //     process.env.VUE_APP_FUNCTIONS_EMULATOR_HOST
    //   );
    //   this._db.settings({
    //     host: process.env.VUE_APP_FIRESTORE_EMULATOR_HOST,
    //     ssl: false,
    //   });
    // }
  }

  public static get instance(): Firebase {
    if (!this._instance) {
      this._instance = new Firebase();
    }
    return this._instance;
  }

  public get auth() {
    return this._auth;
  }

  public get db() {
    return this._db;
  }

  public get functions() {
    return this._functions;
  }
}
